function MapUtil(amap, autoLocation, viewMode) {
    this.amap = amap;
    this.autoLocation = autoLocation;
    this.viewMode = viewMode;
    this.satellite = null;
    this.roadNet = null;
    this.traffic = null;
    this.polygons = null;
    this.position = null;
    this.toolbar = null;
    this.area = 0;
    this.positionCallback = [];
    this.driving = null;
    this.is3D = viewMode == '3D';

    this.init();
};

MapUtil.prototype.init = function () {
    AMap.plugin(['AMap.DistrictSearch', 'AMap.Scale', 'AMap.Geolocation', 'AMap.Driving', 'AMap.Transfer', 'AMap.Riding', 'AMap.Walking', 'AMap.Geocoder'], () => {
        // 创建行政区查询对象
        this.district = new AMap.DistrictSearch({
            subdistrict: 0,   //获取边界不需要返回下级行政区
            extensions: 'all',  //返回行政区边界坐标组等具体信息
            level: 'city'  //查询行政级别为 市
        });

        this.scale = new AMap.Scale();
        this.amap.addControl(this.scale);

        if(this.autoLocation){
            this.geolocation = new AMap.Geolocation({
                enableHighAccuracy: true,//是否使用高精度定位，默认:true
                timeout: 10000,          //超过10秒后停止定位，默认：无穷大
                //buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                zoomToAccuracy: false,      //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                buttonPosition:'RB',
                showMarker: false,        //定位成功后在定位到的位置显示点标记，默认：true
                showCircle: false,        //定位成功后用圆圈表示定位精度范围，默认：true
            });
            var geolocation = this.geolocation;
            this.amap.addControl(geolocation);
            geolocation.getCurrentPosition();
            //AMap.event.addListener(geolocation, 'complete', data => this.onPositionComplete(data));//返回定位信息
            //AMap.event.addListener(geolocation, 'error', data => this.onPositionError(data));      //返回定位出错信息
            geolocation.on('complete', data => this.onPositionComplete(data));
            geolocation.on('error', data => this.onPositionError(data));
        }
    });
};

MapUtil.prototype.addToolBar = function(){
    this.toolbar = new AMap.ToolBar({
        offset: new AMap.Pixel(30, 10),
        visible: true,
        position: 'RB',
    });
    this.amap.addControl(this.toolbar);
};

MapUtil.prototype.getLocation = function(callback){
    if(this.position){
        callback(this.position, this.area);
    }else{
        this.positionCallback.push(callback);
    }
};

MapUtil.prototype.getCity = function(callback){
    this.amap.getCity(function(result){
        if(callback){
            callback(result);
        }
    });
};

MapUtil.prototype.onPositionComplete = function(data){
    console.log(data);
    
    var str=['定位成功'];
    str.push('经度：' + data.position.getLng());
    str.push('纬度：' + data.position.getLat());
    
    if(data.accuracy){
         str.push('精度：' + data.accuracy + ' 米');
    }//如为IP精确定位结果则没有精度信息
    str.push('是否经过偏移：' + (data.isConverted ? '是' : '否'));

    this.position = [data.position.getLng(), data.position.getLat()];
    // var gpsPoint = GPS.gcj_encrypt(data.position.getLat(), data.position.getLng());
    // console.log('convert', gpsPoint);
    // //this.moveTo(gpsPoint);
    // var marker = new AMap.Marker({
    //     position: [gpsPoint.lon, gpsPoint.lat],   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
    //     title: '定位'
    // });
    // this.amap.add(marker);
    // console.log(marker);
    
    this.area = data.addressComponent.adcode || 0;
    //console.log(data, str);
    this.positionCallback.forEach(callback => {
        callback(this.position, this.area);
    });
    this.positionCallback = [];
};

MapUtil.prototype.onPositionError = function(data){
    // console.log('定位失败', data);
    this.positionCallback.forEach(callback => {
        //callback(null);
        //默认深圳坐标
        var defaultPosition = [114.064532, 22.548457];
        this.setZoomAndCenter(14, defaultPosition);
        callback(defaultPosition, 4403);
        
    });
    this.positionCallback = [];
};

MapUtil.prototype.moveTo = function (coordinate) {
    if(coordinate && coordinate.length >= 2){
        this.amap.setCenter(coordinate);
    }
};

MapUtil.prototype.setZoomAndCenter = function(zoomLevel, center){
    this.amap.setZoomAndCenter(zoomLevel, center);
};

MapUtil.prototype.setFitView = function () {
    this.amap.setFitView();
};

MapUtil.prototype.search = function (keyword, level) {
    if(level){
        this.district.setLevel(level);
    }
    this.district.search(keyword, (status, result) => {
        if(status == "no_data"){
            console.log("未找到数据");
            return;
        }
        if(this.polygons != null){
            this.amap.remove(this.polygons);
        }
        // 获取边界信息
        var bounds = result.districtList[0].boundaries
        var polygons = []
        if (bounds) {
            for (var i = 0, l = bounds.length; i < l; i++) {
                //生成行政区划polygon
                var polygon = new AMap.Polygon({
                    map: this.amap,
                    strokeWeight: 1,
                    path: bounds[i],
                    fillOpacity: 0.01,
                    fillColor: '#80d8ff',
                    strokeColor: '#0091ea'
                });
                polygons.push(polygon);
            }
            this.amap.setFitView(polygons);
        }
        this.polygons = polygons;
    });

};

MapUtil.prototype.setCity = function(city, data){
    var zoom = this.amap.getZoom();
    //var zoom = 10;
    
    if(data && data.longitude){
        this.amap.setCenter([data.longitude, data.latitude]);
    }else{
        this.amap.setCity(city);
    }
    //console.log('set city lng', city, data);
    setTimeout(_ => this.amap.setZoom(zoom), 100);
}

MapUtil.prototype.addSatellite = function () {
    if (this.satellite === null) {
        this.satellite = new AMap.TileLayer.Satellite();
    }
    this.amap.add(this.satellite);
};

MapUtil.prototype.removeSatellite = function () {
    if (this.satellite !== null) {
        this.amap.remove(this.satellite);
    }
};

MapUtil.prototype.addLoadNet = function () {
    if (this.roadNet === null) {
        this.roadNet = new AMap.TileLayer.RoadNet();
        this.traffic = new AMap.TileLayer.Traffic({ zIndex: 10 });
    }
    this.amap.add(this.roadNet);
    this.amap.add(this.traffic);
};

MapUtil.prototype.removeLoadNet = function () {
    if (this.roadNet !== null) {
        this.amap.remove(this.roadNet);
        this.amap.remove(this.traffic);
    }
};

MapUtil.prototype.changeMapType = function (type) {
    if (type.toLowerCase() == 'satellite') {
        this.addSatellite();
    } else {
        this.removeSatellite();
    }
};

MapUtil.prototype.getViewList = function (list, defaultBounds){
    var bounds = bounds = this.amap.getBounds();
    var range, areaPath = [];
    //console.log(JSON.stringify(bounds));
    if(defaultBounds){
        areaPath = defaultBounds;
    }else{
        if(this.is3D){
            bounds.bounds.forEach(item => {
                areaPath.push([item.lng, item.lat]);
            })
        }else if(!defaultBounds){
            range = {
                left: bounds.southwest.lng,
                right: bounds.northeast.lng,
                top: bounds.northeast.lat,
                bottom: bounds.southwest.lat
            };
            areaPath = [
                [range.left, range.top],
                [range.right, range.top],
                [range.right, range.bottom],
                [range.left, range.bottom],
                [range.left, range.top],
            ];
        }
    }
    //console.log(JSON.stringify(areaPath));
    // var polyline = new AMap.Polyline({
    //     map: this.amap,
    //     path: areaPath,
    //     strokeColor:'#80d8ff',
    //     strokeWeight: 5
    // });var outList = [];
    var viewList = [];
    list.forEach(item => {
        var point = [item.lng, item.lat];
        var isView = AMap.GeometryUtil.isPointInRing(point, areaPath);
        if(isView){
            viewList.push(item);
        }
    });

    return viewList;
};

MapUtil.prototype.navigation = function(options){
    //console.log(options);
    const {type, from, to, city, panel} = options;
    if(this.driving){
        this.driving.clear();
        this.driving = null;
    }
    switch(type){
        case 1:
            this.driving = new AMap.Driving({
                map: this.amap, panel: panel
            });
            break;
        case 2:
            this.driving = new AMap.Transfer({
                map: this.amap, panel: panel, city: city
            });
            break;
        case 3:
            this.driving = new AMap.Riding({
                map: this.amap, panel: panel
            });
            break;
        case 4:
            this.driving = new AMap.Walking({
                map: this.amap, panel: panel
            });
            break;
    }

    if(this.driving){
        this.driving.search(from, to, function(status, result) {
            var success;
            if (status === 'complete') {
                success = true;
                console.log('绘制驾车路线完成');
            } else {
                success = false;
                console.log('获取驾车数据失败：' + result)
            }
            if(options.callback){
                options.callback(success);
            }
        });
    }
    return this.driving;
};

export default MapUtil;